/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_User_Invitation_Requires_EmailInputs */

const en_api_error_user_invitation_requires_email = /** @type {(inputs: Api_Error_User_Invitation_Requires_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This user does not have an email address for invitation delivery.`)
};

const pt_br2_api_error_user_invitation_requires_email = /** @type {(inputs: Api_Error_User_Invitation_Requires_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este usuário não possui um endereço de e-mail para receber o convite.`)
};

/**
* | output |
* | --- |
* | "This user does not have an email address for invitation delivery." |
*
* @param {Api_Error_User_Invitation_Requires_EmailInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_user_invitation_requires_email = /** @type {((inputs?: Api_Error_User_Invitation_Requires_EmailInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_User_Invitation_Requires_EmailInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_user_invitation_requires_email(inputs)
	return pt_br2_api_error_user_invitation_requires_email(inputs)
});